import { render, staticRenderFns } from "./GroupMembershipTable.vue?vue&type=template&id=68a013d9&scoped=true&"
import script from "./GroupMembershipTable.vue?vue&type=script&lang=js&"
export * from "./GroupMembershipTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a013d9",
  null
  
)

export default component.exports